import {Controller, useFormContext} from 'react-hook-form'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {DateTimePicker} from '@mui/x-date-pickers/DateTimePicker'
import {styled} from 'common'
import dayjs from 'dayjs'
import {DemoItem} from '@mui/x-date-pickers/internals/demo'
import 'dayjs/locale/he'
import 'dayjs/locale/en'
import {heIL, enUS} from '@mui/x-date-pickers/locales'
import storage from 'services/storage'
import {useTranslation} from 'react-i18next'

const FormDatePicker = ({name, label, i18nCategory, rules, error, _defaultValue}) => {
    const {control} = useFormContext()
    const {t} = useTranslation()

    const currentLanguage = storage.getLanguage() || 'he'
    dayjs.locale(currentLanguage)

    const localeMap = {
        he: heIL,
        en: enUS,
    }

    const currentLocale = localeMap[currentLanguage] || localeMap.he

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({field}) => (
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale={currentLanguage}
                    localeText={
                        currentLocale.components.MuiLocalizationProvider.defaultProps.localeText
                    }>
                    <DemoItem component="DateTimeRangePicker">
                        <DateTimePickerStyled
                            label={t(`${i18nCategory}.${label}`)}
                            views={['year', 'month', 'day', 'hours', 'minutes']}
                            value={field.value ? dayjs(field.value) : null}
                            onChange={field.onChange}
                            format="DD/MM/YYYY HH:mm"
                            ampm={false}
                            slotProps={{
                                textField: {
                                    variant: 'standard',
                                    error: !!error,
                                    helperText: error?.message && t(`error.${error?.message}`),
                                },
                                field: {clearable: true},
                            }}
                        />
                    </DemoItem>
                </LocalizationProvider>
            )}
        />
    )
}

export default FormDatePicker

const DateTimePickerStyled = styled(DateTimePicker)`
    width: 100%;
`
